<template>
  <b-table show-empty striped hover class="aco-table"
           :empty-text="$t('noResults')"
           :items="orders" :fields="orderFields">
    <template v-slot:cell(customerOrganizationName)="data">
      <div v-if="data.item.customerOrganizationName !== null">{{ data.item.customerOrganizationName }}</div>
      <div v-else-if="data.item.customerContactName !== null">{{ data.item.customerContactName }}</div>
      <div v-else>{{ data.item.customerContactEmail }}</div>
    </template>

    <template v-slot:cell(show_details)="row">
      <router-link :to="{ name: 'OrderDetails', params: { id: row.item.orderId }}">
        <b-button size="sm" class="py-0">{{ $t('details') }}</b-button>
      </router-link>
    </template>
  </b-table>
</template>

<script>
  import BaseComponent from '../../components/BaseComponent'
  import { mapGetters } from 'vuex'

  export default {
    name: 'OrderList',
    extends: BaseComponent,

    created: function () {
      this.$store.dispatch('orders/getOrders')
    },
    computed: {
      ...mapGetters('orders', ['orders']),
      orderFields () {
        return [
          { key: 'orderId', label: this.$t('orderId') },
          { key: 'orderStatus', label: this.$t('status'), formatter: value => this.translateAlternatives('constants', value) },
          { key: 'orderSource', label: this.$t('orderSource'), formatter: value => this.translateAlternatives('orderSources', value) },
          { key: 'buyerOrganizationName', label: this.$t('buyer') },
          { key: 'customerOrganizationName', label: this.$t('customer') },
          { key: 'created', label: this.$t('created'), tdClass: 'text-nowrap', formatter: 'formatTimestamp' },
          { key: 'show_details', label: '' }
        ]
      }
    }
  }
</script>
